import type { UserRole } from "@/types/domain";

const ORDERING_ACCOUNT_TYPES: readonly UserRole[] = [
  "agronomist_agent",
  "agronomist_admin",
];

export function isOrderingAccountType(
  userType: UserRole | null | undefined,
): boolean {
  return Boolean(userType && ORDERING_ACCOUNT_TYPES.includes(userType));
}

export function getAccountHomePath(
  userType: UserRole | null | undefined,
): "/" | "/ordering" {
  return isOrderingAccountType(userType) ? "/ordering" : "/";
}

export function getPostLoginPath(
  userType: UserRole | null | undefined,
  intended?: string,
): string {
  if (userType === "admin") {
    return getAccountHomePath(userType);
  }

  return intended || getAccountHomePath(userType);
}
